export const DEFAULT_WORKFLOW_STATES = [
    { id: 'backlog', name: 'Backlog', color: '#94a3b8', order: 0 },
    { id: 'to-do', name: 'To Do', color: '#3b82f6', order: 1 },
    { id: 'in-progress', name: 'In Progress', color: '#f59e0b', order: 2 },
    { id: 'in-review', name: 'In Review', color: '#8b5cf6', order: 3 },
    { id: 'done', name: 'Done', color: '#22c55e', order: 4 },
];
export function ensureDefaultStates(states) {
    if (!states || states.length === 0) {
        return DEFAULT_WORKFLOW_STATES.map(s => ({ ...s }));
    }
    return states.map(s => ({ ...s }));
}
//# sourceMappingURL=defaults.js.map